import { normalizeThemeRequest } from '../utils/normalizeThemeId';
import { orchestrator } from 'satcheljs';
import { changeTheme as changeFabricTheme } from 'owa-fabric-theme';
import loadThemeAction from '../actions/loadTheme';
import getPalette from '../selectors/getPalette';
import setCurrentTheme from '../mutators/setCurrentTheme';
import setCssVariablesOnDocument from '../utils/setCssVariablesOnDocument';
import { isUserPersonalizationAllowed } from '../selectors/isUserPersonalizationAllowed';
import { getOpxHostApi, isOpx } from 'owa-opx';
import { hasQueryStringParameter } from 'owa-querystring';

export default orchestrator(loadThemeAction, async message => {
    let { themeId, isDarkTheme } = normalizeThemeRequest(
        message.themeId,
        message.isDarkTheme,
        typeof message.themesAllowed === 'boolean'
            ? message.themesAllowed
            : isUserPersonalizationAllowed()
    );

    const host = isOpx() ? await getOpxHostApi() : undefined;
    let palette = !hasQueryStringParameter('useOwaTheme') && host && host.getOpxPalette();
    if (!palette) {
        const hostDarkTheme = host && (await host.isDarkTheme());
        palette = getPalette(
            themeId,
            typeof hostDarkTheme == 'boolean' ? hostDarkTheme : isDarkTheme
        );
    }

    setCurrentTheme(themeId);

    changeFabricTheme(palette, !!isDarkTheme);
    setCssVariablesOnDocument();
});
